// src/pages/PoliticaSeguridad.js
import React from 'react';
import "./LegalPages.css";

function PoliticaSeguridad() {
  return (
    <div className="legal-page">
      <h1>📌 POLÍTICA DE SEGURIDAD - SANTO DOMINGO ESPECTÁCULOS</h1>
      <p>En Santo Domingo Espectáculos, la seguridad de nuestros usuarios es una prioridad. Implementamos medidas de protección avanzadas para resguardar la información personal y financiera de nuestros clientes.</p>
      
      <h2>1. Seguridad en la Plataforma Web</h2>
      
      <h3>🔹 Protección de datos personales</h3>
      <p>Nos comprometemos a proteger la privacidad de nuestros usuarios. Para ello, aplicamos medidas de seguridad robustas y cumplimos con todas las leyes y regulaciones aplicables en materia de protección de datos.</p>
      
      <h3>🔹 Gestión de contraseñas</h3>
      <ul>
        <li>✔ Se exige una contraseña con alta complejidad.</li>
        <li>✔ Se implementa una política de cambio de contraseñas periódica.</li>
        <li>✔ Se ofrece un proceso seguro de recuperación de contraseñas.</li>
      </ul>
      
      <h3>🔹 Protección contra ataques cibernéticos</h3>
      <ul>
        <li>✔ Firewalls y encriptación avanzada.</li>
        <li>✔ Sistemas de detección de intrusiones.</li>
        <li>✔ Monitoreo de seguridad en tiempo real.</li>
      </ul>
      
      <h3>🔹 Política de seguridad para terceros</h3>
      <p>Cualquier proveedor o tercero con acceso a nuestra plataforma o datos de usuarios deberá cumplir con estrictas normativas de seguridad y privacidad para garantizar la protección de la información.</p>
      
      <h3>🔹 Política de seguridad de empleados</h3>
      <ul>
        <li>✔ Todo el personal que tenga acceso a la plataforma recibe capacitación en seguridad y privacidad.</li>
        <li>✔ El acceso a la información está restringido solo a empleados con funciones específicas que lo requieran.</li>
      </ul>
      
      <h3>🔹 Monitoreo y auditoría</h3>
      <p>Implementamos un sistema de monitoreo continuo para detectar y abordar cualquier actividad sospechosa. Además, realizamos auditorías periódicas para verificar el cumplimiento de nuestras medidas de seguridad.</p>
      
      <h3>🔹 Cumplimiento normativo</h3>
      <p>Cumplimos con todas las leyes y regulaciones aplicables sobre seguridad y privacidad, asegurando un monitoreo constante para su cumplimiento.</p>
      
      <h2>2. Seguridad en el Procesamiento de Pagos</h2>
      <p>La seguridad de la información de pago es fundamental en nuestra plataforma. Aplicamos tecnologías avanzadas para proteger la información financiera de los usuarios.</p>
      
      <h3>🔹 Medidas de seguridad implementadas</h3>
      <ul>
        <li>✔ Cifrado SSL para proteger la transmisión de datos.</li>
        <li>✔ Verificación de dirección de facturación para prevenir fraudes.</li>
        <li>✔ Validación de tarjetas de crédito con autenticación segura.</li>
      </ul>
      
      <h3>🔹 Métodos de pago aceptados</h3>
      <p>Trabajamos con proveedores de pago confiables y seguros, tales como:</p>
      <ul>
        <li>✔ CardNet</li>
        <li>✔ VisaNet</li>
        <li>✔ AZUL</li>
        <li>✔ PayPal</li>
        <li>✔ Stripe</li>
      </ul>
      <p>📌 Estos servicios cumplen con los estándares más altos de seguridad y cifrado para mantener segura la información financiera del usuario.</p>
      
      <h3>🔹 Recomendaciones de seguridad</h3>
      <p>Recomendamos a nuestros clientes leer las Políticas de Privacidad de los proveedores de pago para comprender mejor cómo manejan la información suministrada.</p>
    </div>
  );
}
export default PoliticaSeguridad;
